import { Injectable, signal } from '@angular/core';

export type AdminToast = {
  id: number;
  message: string;
  variant: 'success' | 'error';
};

@Injectable({ providedIn: 'root' })
export class AdminToastService {
  private nextId = 0;
  readonly toasts = signal<AdminToast[]>([]);

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'error');
  }

  private show(message: string, variant: 'success' | 'error'): void {
    const id = ++this.nextId;
    this.toasts.update((items) => [...items, { id, message, variant }]);
    setTimeout(() => this.dismiss(id), 4000);
  }

  dismiss(id: number): void {
    this.toasts.update((items) => items.filter((t) => t.id !== id));
  }
}
